module.exports = __webpack_public_path__ + "static/media/credit-card-regular.b98dbc5f.svg";